// eslint-disable-next-line no-shadow
export enum TableStaticColumns {
    client = "Client",
    crmAccount = "CRM Account",
    oppurtunityOwner = "Opportunity Owner",
    office = "Office",
    expiryDate = "Expiry Date",
    wording = "Claim Wording",
    view = "View"
}

export enum TableFieldNames {
    client = "client",
    sfAccount = "salesforceAccountId",
    oppurtunityOwner = "opportunityOwner",
    office = "Office",
    expiryDate = "expiryDate",
    wording = "wording"
}